import axios from 'axios';
import { DOMAIN, ROOT_DIR, MONTHS, ListAPIKey } from './Constants';

function search(keyword, cb){
  var CancelToken = axios.CancelToken;
  var source = CancelToken.source();
  var url = window.location.href;
  
  // if another request is made before this one finishes (selecting a category), cancel this one
  var checkRequests = setInterval(function(){ 
    var newUrl = window.location.href;
    if(newUrl.indexOf('/search/') === -1 ){
      clearInterval(checkRequests);
      source.cancel();
    }
   }, 50);

   axios.get(`http://www.${DOMAIN}/places.php?search=${keyword}&type=all`, {
      cancelToken: source.token,
    })
    .then(function (response) {
      clearInterval(checkRequests);
      cb(response.data, keyword);
    })
    .catch(function (error) {
      if (axios.isCancel(error)) {
        //console.log('Request canceled', error.message);
      } else {
        // handle error
        console.log(error.message);
      }
    });
}

function getList(val, cb) {
  var CancelToken = axios.CancelToken;
  var source = CancelToken.source();
  var url = window.location.href;
  
  // if another request is made before this one finishes, cancel this one
  var checkRequests = setInterval(function(){ 
    var newUrl = window.location.href;

    if(newUrl !== url){
      clearInterval(checkRequests);
      source.cancel();
    }
   }, 50);

  axios.get(`http://www.${DOMAIN}/places.php?type=${val.type}`, {
    cancelToken: source.token
  })
  .then(function (response) {
    clearInterval(checkRequests);
    cb(response.data, val);
  })
  .catch(function (error) {
    if (axios.isCancel(error)) {
      //console.log('Request canceled', error.message);
    } else {
      // handle error
      console.log(error.message);
    }
  });
}

function getPriorityList(query, cb){
  axios.get(`${ROOT_DIR}/data/priority-businesses.json`, {
    
  })
  .then(function (response) {
    var newArr = [];
    query = query.toLowerCase();
    response.data.forEach((val, idx) => {
      var arr = val.types.split(',');
      arr.forEach(function(v, i){
        if(v.trim() === query && query !== ''){
          newArr.push(val);
        }
      })
    });
    cb(newArr);
  })
  .catch(function (error) {
    console.log(error.message);
  });
}

function getPriorityById(id, cb){
  axios.get(`${ROOT_DIR}/data/priority-businesses.json`, {
    
  })
  .then(function (response) {
    var obj = {};

    response.data.forEach((val, idx) => {
      if(id === val.id) {
        obj = val;
      }
    });
    cb(obj);
  })
  .catch(function (error) {
    console.log(error.message);
  });
}

function triggerTracking(){
  axios.post(`${ROOT_DIR}/special/tracking.php?r=${document.referrer}`, {
    
  })
  .then(function (response) {
    console.log(document.referrer);
  })
  .catch(function (error) {
    console.log(error.message);
  });
}

function getTweets(cb){
  // axios.get(`${ROOT_DIR}/get_tweets.php`, {
  axios.get(`http://www.${DOMAIN}/get_tweets.php`, {
    
  })
  .then(function (response) {
    cb(response.data);
  })
  .catch(function (error) {
    console.log(error.message);
  });

}

function getEventsEventbrite(cb){
  var today = new Date();
  var startDate = today.toISOString().substring(0,19);

  // axios.get('https://www.eventbriteapi.com/v3/events/search/?location.latitude=51.583369&location.longitude=0.488701&location.within=2mi&sort_by=date&start_date.range_start=' + startDate, {
  //   headers: {'Authorization': 'Bearer QGC2S3V6ZWDSI66UVQOA'}
  // })
  axios.get('https://www.eventbriteapi.com/v3/events/search/?q=Basildon&sort_by=date&start_date.range_start=' + startDate, {
    headers: {'Authorization': 'Bearer QGC2S3V6ZWDSI66UVQOA'}
  })
  .then(function (response) {
    var partList = response.data.events.slice(0,15);
    cb(partList);
  });

}
function getEvents(cb){

  axios.get(`${ROOT_DIR}/data/events.json`, {
    
  })
  .then(function (response) {
    var newArr = [];
    response.data.forEach((val, idx) => {
      var today = new Date();
     
      var eventDate = new Date(val.date);
      val.system_date = eventDate;
      console.log(val.date, eventDate);
      if(today < eventDate || eventDate.setHours(0,0,0,0) == today.setHours(0,0,0,0)) {
        newArr.push(val);
      }
    });
    cb(newArr);
  })
  .catch(function (error) {
    console.log(error.message);
  });

}

const Client = { getList, search, getPriorityList, triggerTracking, getTweets, getEvents, getEventsEventbrite, getPriorityById };
export default Client;


// WEBPACK FOOTER //
// ./src/utils/Client.js